import { ClientMenuCategoryDto, ClientMenuItemDto } from '@/app/store/api/restApi';

export const getNonEmptyCategories = (
  categories: ClientMenuCategoryDto[],
  menuItems: ClientMenuItemDto[],
): ClientMenuCategoryDto[] => categories.filter((category) => menuItems.some((mi) => mi.categoryId === category.id));
